import { render } from "./oficialiaTurnados.vue?vue&type=template&id=f99f4e5e&scoped=true"
import script from "./oficialiaTurnados.vue?vue&type=script&lang=js"
export * from "./oficialiaTurnados.vue?vue&type=script&lang=js"

import "./oficialiaTurnados.vue?vue&type=style&index=0&id=f99f4e5e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f99f4e5e"]])

export default __exports__